import { Link } from 'react-router-dom';

const CTASection = () => {
  return (
    <section className="py-24 bg-[#8B9D7C] relative overflow-hidden">
      <div className="absolute inset-0 opacity-10">
        <svg className="w-full h-full" xmlns="http://www.w3.org/2000/svg">
          <pattern id="leaf-pattern" x="0" y="0" width="100" height="100" patternUnits="userSpaceOnUse">
            <path d="M50 10 Q60 30 50 50 Q40 30 50 10" fill="currentColor" className="text-white" />
          </pattern>
          <rect width="100%" height="100%" fill="url(#leaf-pattern)" />
        </svg>
      </div>

      <div className="max-w-7xl mx-auto px-6 relative z-10">
        <div className="text-center mb-12">
          <div className="inline-block px-6 py-2 border border-white rounded-full mb-6">
            <span className="text-white text-sm font-medium">Unisciti a Noi</span>
          </div>
          <h2 className="text-5xl md:text-6xl font-serif text-white mb-6">
            Inizia il Tuo Viaggio<br />nel Biologico
          </h2>
          <p className="text-white/85 text-xl max-w-2xl mx-auto mb-8">
            Scopri la differenza che fanno ingredienti autentici e di qualità superiore
          </p>
          <Link
            to="/prodotti"
            className="inline-flex items-center px-8 py-4 bg-white text-[#2D5016] rounded-full text-lg font-medium hover:bg-gray-100 transition-all duration-300 shadow-lg cursor-pointer whitespace-nowrap"
          >
            Esplora i Prodotti
            <i className="ri-arrow-right-line ml-2"></i>
          </Link>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-8 mt-16">
          <div className="text-center">
            <div className="w-16 h-16 flex items-center justify-center bg-white/20 rounded-full mx-auto mb-4">
              <i className="ri-leaf-line text-white text-3xl"></i>
            </div>
            <h3 className="text-white text-xl font-semibold mb-2">100% Biologico</h3>
            <p className="text-white/80 text-sm">
              Certificazioni biologiche per ogni prodotto
            </p>
          </div>

          <div className="text-center">
            <div className="w-16 h-16 flex items-center justify-center bg-white/20 rounded-full mx-auto mb-4">
              <i className="ri-truck-line text-white text-3xl"></i>
            </div>
            <h3 className="text-white text-xl font-semibold mb-2">Spedizione Veloce</h3>
            <p className="text-white/80 text-sm">
              Consegna gratuita per ordini oltre €30
            </p>
          </div>

          <div className="text-center">
            <div className="w-16 h-16 flex items-center justify-center bg-white/20 rounded-full mx-auto mb-4">
              <i className="ri-customer-service-2-line text-white text-3xl"></i>
            </div>
            <h3 className="text-white text-xl font-semibold mb-2">Supporto Dedicato</h3>
            <p className="text-white/80 text-sm">
              Il nostro team è sempre a tua disposizione
            </p>
          </div>
        </div>
      </div>
    </section>
  );
};

export default CTASection;